import { fromJS, Map, List } from 'immutable'
import _ from 'lodash'
import { ftDeleteOfflineValue, ftSetOfflineValue, ftGetOfflineValue } from '../../lib/offline-storage'
import { getParams, getState } from '../../lib/processPortalRules'
import { getAxios } from '../../lib/projectAxios'
import { setVisibilityOfSFMappingElem } from '../../lib/setVisibilityOfSFMappingElem'
import { PROCESS_SF_MAPPING, SET_STORE } from './actionTypes'
import { recursivePrepareSFMapping } from './recursivePrepareSFMapping'

let prevPromise = null
const axios = getAxios()

export const getCacheKey = () => '/ftproject/fetch-data' //_.get(window, '__FT__APP__STATE.cacheKey', null)

export const sfClearCacheData = async () => {
  const cacheKey = getCacheKey()
  if (!cacheKey) {
    return {
      status: false,
    }
  }
  try {
    await ftDeleteOfflineValue(cacheKey)
    return {
      status: true,
    }
  } catch (error) {
    console.error(error)
    return {
      status: false,
    }
  }
}

export const sfGetCacheData = async () => {
  const cacheKey = getCacheKey()
  if (!cacheKey) {
    return {
      status: false,
    }
  }
  try {
    return {
      status: true,
      data: await ftGetOfflineValue(cacheKey),
    }
  } catch (error) {
    console.error(error)
    return {
      status: false,
    }
  }
}

export const isAllowProcessSFFetchCacheData = (state) => {
  // console.log('isAllowProcessSFFetchCacheData >>>')
  // return true
  return !navigator.onLine && state.getIn(['project', 'Settings', 'ui', 'pwa', 'sfFetch', 'enable'], false)
}

export const asyncIsAllowProcessSFFetchCacheData = async (state) => {
  if (state.getIn(['project', 'Settings', 'ui', 'pwa', 'sfFetch', 'enable'], false)) {
    try {
      // return true
      const { status, data } = await axios.post('/webprojects/online')
      if (status === 200 && data.status) {
        return false
      }
    } catch (error) {}
    return true
  } else {
    return true
  }
}

const buildFilterRow = (conditions, reqParams) => (row) => {
  if (_.size(conditions) === 0) {
    return true
  }
  /*
    {
      postCondition: 'and',
      conditionType: 'string',
      name: 'Id',
      sfType: 'id',
      refField: null,
      operator: 'equals',
      field: {
        value: 'cf50e0e2-8873-4915-a208-423d6888022c',
        label: 'edit-user',
        subType: 'static',
        group: 'param'
      },
      uid: 'param#-#cf50e0e2-8873-4915-a208-423d6888022c'
    }
    */
  const staticValues = []
  const instructions = []
  _.each(conditions, (cond, index) => {
    let isNeedPostCond = true
    if (conditions.length - 1 === index) {
      isNeedPostCond = false
    }
    try {
      if (_.get(conditions, [index + 1, 'name']) == ')') {
        isNeedPostCond = false
      }
      if (cond.name == '(' || cond.name == ')') {
        let postVal = _.get(cond, 'postCondition', 'and') || 'and'
        if (conditions.length == 1) {
          postVal = ''
        }
        let postCond = ''
        if (isNeedPostCond && cond.name != '(') {
          if (postVal === 'and') {
            postCond = ' && '
          }
          if (postVal === 'or') {
            postCond = ' || '
          }
        } else {
          postVal = ''
        }

        instructions.push(` ${cond.name} ${postCond} `)
        return true
      }
    } catch (err) {
      console.error(err)
    }

    let startBracket = cond.bracket === '(' ? '(' : ''
    let endBracket = cond.bracket === ')' ? ')' : ''
    if (index == 0) {
      endBracket = ''
    }
    let postVal = _.get(cond, 'postCondition', 'and') || 'and'
    if (conditions.length === 1) {
      startBracket = ''
      postVal = ''
    }
    let postCond = ''
    if (isNeedPostCond) {
      if (postVal === 'and') {
        postCond = ' && '
      }
      if (postVal === 'or') {
        postCond = ' || '
      }
    }
    let leftVal = `row['${cond.name}']`
    let rightVal = `staticValues[${staticValues.length}]`

    if (cond.uid === 'static') {
      staticValues.push(_.toLower(cond.staticValue || ''))
    } else if (cond.uid === 'static-boolean-false') {
      staticValues.push(false)
    } else if (cond.uid === 'static-boolean-true') {
      staticValues.push(true)
    } else {
      staticValues.push(_.toLower(reqParams[cond.uid]))
    }

    if (['(', ')'].includes(cond.name)) {
      instructions.push(cond.name)
    } else {
      switch (cond.operator) {
        case 'equals':
          instructions.push(`${startBracket} _.toLower(${leftVal}) === ${rightVal} ${endBracket} ${postCond}`)
          break
        case 'notequal':
          instructions.push(`${startBracket} _.toLower(${leftVal}) !== ${rightVal} ${endBracket} ${postCond}`)
          break
        case 'contains':
          instructions.push(`${startBracket} _.includes(_.toLower(${leftVal}), ${rightVal}) ${endBracket} ${postCond}`)
          break
        case 'notcontain':
          instructions.push(`${startBracket} !_.includes(_.toLower(${leftVal}), ${rightVal}) ${endBracket} ${postCond}`)
          break
        case 'in':
          instructions.push(
            `${startBracket} _.includes(_.toLower(${leftVal}).replace(/;/g, ',').split(','), ${rightVal}) ${endBracket} ${postCond}`
          )
          break
        case 'notin':
          instructions.push(
            `${startBracket} !_.includes(_.toLower(${leftVal}).replace(/;/g, ',').split(','), ${rightVal}) ${endBracket} ${postCond}`
          )
          break
        // case 'includes':
        // case 'includesOr':
        // case 'excludes':
        // case 'excludesOr':
        case 'searchPattern':
          break
        case 'searchPatternAnd':
          break
        case 'startswith':
          instructions.push(
            `${startBracket} _.startsWith(_.toLower(${leftVal}), ${rightVal}) ${endBracket} ${postCond}`
          )
          break
        case 'endswith':
          instructions.push(`${startBracket} _.endsWith(_.toLower(${leftVal}), ${rightVal}) ${endBracket} ${postCond}`)
          break
        case 'greaterThan':
          instructions.push(`${startBracket} ${leftVal} > ${rightVal} ${endBracket} ${postCond}`)
          break
        case 'greaterEqualThan':
          instructions.push(`${startBracket} ${leftVal} >= ${rightVal} ${endBracket} ${postCond}`)
          break
        case 'lessorThan':
          instructions.push(`${startBracket} ${leftVal} < ${rightVal} ${endBracket} ${postCond}`)
          break
        case 'lessorEqualThan':
          instructions.push(`${startBracket} ${leftVal} <= ${rightVal} ${endBracket} ${postCond}`)
          break
        case 'isempty':
          instructions.push(
            `${startBracket} (${leftVal} === undefined || ${leftVal} === '' || ${leftVal} === null || ${leftVal} === 0 || (_.isArray(${leftVal}) || _.isObject(${leftVal})) && _.size(${leftVal}) === 0) ${endBracket} ${postCond}`
          )
          break
        case 'isnotempty':
          instructions.push(
            `${startBracket} ${leftVal} !== undefined && ${leftVal} !== '' && ${leftVal} !== null && ${leftVal} !== 0 ${endBracket} ${postCond}`
          )
          break
      }
    }
  })
  if (instructions.length === 0) {
    instructions.push(`true`)
  }
  // console.log('command \n\n', `(function(row, reqParams, staticValues, _) { return ${instructions.join(' ')}; })`, '\n\n')
  const func = eval(`(function(row, reqParams, staticValues, _) { return ${instructions.join(' ')}; })`)
  return func(row, reqParams, staticValues, _)
}

export const processSFFetchCacheData = (list, repeatIndex) => async (dispatch, getAppState) => {
  let state = getAppState()
  const sfMapping = state.getIn(['project', 'Settings', 'sfMapping'], Map()).toJS()
  state = setVisibilityOfSFMappingElem(sfMapping, list, false, null, state)
  dispatch({
    type: SET_STORE,
    payload: {
      store: state,
    },
  })
  state = getAppState()
  const { status, data } = await sfGetCacheData()
  if (!status) {
    console.log('No Cached sf data')
    return null
  }
  // console.log('processSFFetchCacheData >>>', list)
  _.each(list, (val, key) => {
    let sfItem = sfMapping[key]
    if (!sfItem) {
      return null
    }
    // console.log('Processing %O', sfItem)
    let object = sfItem.sobject
    let cacheEntry = _.find(data, (val) => val.name === object)
    if (!cacheEntry) {
      console.log('No cached data for %s', object)
      return null
    }
    let rows = cacheEntry.rows || []
    if (!_.isArray(rows)) {
      rows = [rows]
    }
    let filteredRows = _.filter(rows, buildFilterRow(sfItem.conditions || [], val))
    let totalRows = filteredRows.length
    let itemData = _.reduce(
      sfItem.gridFieldsOrigin,
      (r, v, k) => ({
        ...r,
        ...(_.endsWith(k, 'totalRows') ? { [k]: totalRows } : { [k]: sfItem.isArray ? [] : null }),
      }),
      {}
    )
    // console.log('>>>', totalRows, itemData)
    if (sfItem.isArray) {
      _.each(filteredRows, (row) => {
        _.each(sfItem.gridFieldsOrigin, (field, key) => {
          if (!_.endsWith(key, 'totalRows')) {
            itemData[key].push(row[field])
          }
        })
      })
    } else {
      _.each(sfItem.gridFieldsOrigin, (field, key) => {
        if (!_.endsWith(key, 'totalRows')) {
          itemData[key] = filteredRows[0]?.[field] ?? null
        }
      })
    }
    // console.log('itemData >>>', itemData)
    dispatch({
      type: PROCESS_SF_MAPPING,
      payload: {
        data: {
          data: itemData,
        },
        list: {
          [key]: val,
        },
        repeatIndex,
        isShowLoading: false,
        loadingMessages: {},
        sfMessages: {},
      },
    })
  })
}

export const sfFetchCacheData =
  (ignoreCache = false) =>
  async (dispatch, getAppState) => {
    const cacheKey = getCacheKey()
    if (!cacheKey && typeof fetch !== 'function') {
      return {
        status: false,
      }
    }
    try {
      let json
      if (!ignoreCache) {
        json = ftGetOfflineValue(cacheKey)
      }
      if (json) {
        return json
      } else if (navigator.onLine) {
        let appState = getAppState()
        let state = getState(appState)
        let params = getParams(appState)
        let fetchList = appState.getIn(['project', 'Settings', 'ui', 'pwa', 'sfFetch', 'list'], List()).toJS()
        let sfMapping = appState.getIn(['project', 'Settings', 'sfMapping'], Map()).toJS()
        let messages = []
        let list = recursivePrepareSFMapping(
          sfMapping,
          'custom',
          [],
          state,
          params,
          false,
          messages,
          _.reduce(
            fetchList,
            (r, v) => ({
              ...r,
              [v.value]: v,
            }),
            {}
          ),
          {
            list: fetchList,
          }
        )
        let data = {
          list,
        }
        const { status, data: reply } = await axios.post('/ftproject/fetch-data', data)
        if (status === 200) {
          await ftSetOfflineValue(cacheKey, reply.data)
          return reply.data
        }
      }
      return {
        status: false,
        error: 'no-cache',
      }
    } catch (error) {
      console.error(error)
      return {
        status: false,
      }
    }
  }

export const cleanOldAppStateCache = () => async (dispatch, getState) => {
  const projectID = getState().getIn(['project', '_id'])
  if (prevPromise instanceof Promise) {
    await prevPromise
  }
  if (navigator.onLine) {
    prevPromise = ftDeleteOfflineValue(`ftState_${projectID}`)
  }
}

export const updateAppStateCache = (state, rules, meta, params, filter, metaInfo) => async (dispatch, getState) => {
  const projectID = getState().getIn(['project', '_id'])
  if (prevPromise instanceof Promise) {
    await prevPromise
  }
  prevPromise = ftSetOfflineValue(`ftState_${projectID}`, {
    state: state.toJS(),
    rules: rules.toJS(),
    meta: meta.toJS(),
    params: params.toJS(),
    filter: filter.toJS(),
    metaInfo: metaInfo.toJS(),
  })
}

export const loadAppPrevStateIfExist = () => async (dispatch, getState) => {
  if (!navigator.onLine) {
    let state = getState()
    const projectID = state.getIn(['project', '_id'])
    let prevState = await ftGetOfflineValue(`ftState_${projectID}`)
    if (
      prevState &&
      (prevState.state ||
        prevState.rules ||
        prevState.meta ||
        prevState.params ||
        prevState.filter ||
        prevState.metaInfo)
    ) {
      state = getState()
      state = state
        .set('state', fromJS(prevState.state || {}))
        .set('rules', fromJS(prevState.rules || {}))
        .set('meta', fromJS(prevState.meta || {}))
        .set('params', fromJS(prevState.params || {}))
        .set('filter', fromJS(prevState.filter || {}))
        .set('metaInfo', fromJS(prevState.metaInfo || {}))
      dispatch({
        type: SET_STORE,
        payload: {
          store: state,
        },
      })
    }
  }
}
